import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@maui/elements'
import { UpgradePanel, UpgradeRow } from '@maui/freemium'

export const UpgradeGroup = ({ children: headings, ...restProps }) => {
  return (
    <>
      <Box width='180px' paddingRight='20px'>
        { headings }
      </Box>
      <Box flex="1" mt="24px">
        { restProps.layout === 'row' &&
          <UpgradeRow width="100%" showDescription {...restProps} buttonProps={{ as: 'a' }} />
        }
        { restProps.layout === 'panel' &&
          <UpgradePanel width="100%" showDescription {...restProps} buttonProps={{ as: 'a' }} />
        }
      </Box>
    </>
  )
}

UpgradeGroup.propTypes = {
  children: PropTypes.node,
}

export default UpgradeGroup
